import styled from 'styled-components';

export const Container = styled.div`
  .modal-header {
    background: ${(props) => props.theme.$dark} !important;
  }
`;
